var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],class:_vm.getClasses,attrs:{"height":"auto","fixed":"","color":"accent","aria-label":"Take Action Footer"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }